import request from '@/utils/request'

export interface ConsultCallsParams {
  tab: 'answered' | 'missed' | 'failed'
  text?: string
  country?: string
  userId?: string
  startDate?: string
  endDate?: string
  category?: string
  page?: number
  pageSize?: number
}

export const getConsultCalls = (params: ConsultCallsParams) =>
  request({ url: '/admin/consult-calls', method: 'get', params })

export const getConsultCallCategories = () =>
  request({ url: '/admin/consult-calls/categories', method: 'get' })

export const getConsultCallsCounts = (params: Omit<ConsultCallsParams, 'tab' | 'page' | 'pageSize'>) =>
  request({ url: '/admin/consult-calls/counts', method: 'get', params })
